import { render, staticRenderFns } from "./Settings_DataTypes.vue?vue&type=template&id=216f0ad8&scoped=true"
import script from "./Settings_DataTypes.vue?vue&type=script&lang=js"
export * from "./Settings_DataTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216f0ad8",
  null
  
)

export default component.exports